import PropTypes from 'prop-types';
import InputTextLine from '../../../../juristec-ui/core/InputTextLine';

const TextInput = ({
  label, state, handle, blur,
}) => (
  <>
    <h5 className={state.error ? 'field-error-label' : ''}>
      {label}
    </h5>
    <InputTextLine
      value={state.value}
      // errorMessage={state.errorMsg}
      // error={state.errorMsg.length > 0}
      onChange={handle}
      onBlur={blur}
    />
    {state.errorMsg.length > 0 && (
      <span className="field-error-msg">
        {state.errorMsg}
      </span>
    )}
  </>
);

TextInput.propTypes = {
  label: PropTypes.string.isRequired,
  state: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.bool,
    errorMsg: PropTypes.string,
  }).isRequired,
  handle: PropTypes.func.isRequired,
  blur: PropTypes.func.isRequired,
};

export default TextInput;
